/**
 * Instrument label shown across the DCF tool. Study staff recognise the display
 * name, so the internal title is only a fallback.
 */
const getInstrumentDisplayName = instrument => {
  const candidates = [
    instrument?.metadata?.display_name,
    instrument?.display_name,
    instrument?.displayName,
    instrument?.title,
  ]
  const label = candidates.find(value => value != null && String(value).trim() !== '')
  if (label) return String(label).trim()
  return instrument?.id != null ? `Instrument ${instrument.id}` : ''
}

export default getInstrumentDisplayName
